import debounce from 'lodash/debounce';

import { toggleAttribute } from '../Helper/helper';

document.addEventListener("DOMContentLoaded", function() {

	// Main menu
	const HEADER = $('#header');
	const MAIN_MENU = $('.header__mainmenu');
	const MAIN_MENU_LINK = $('.header__mainmenu-link[role="button"]');
	const MAIN_MENU_LINK_ACTIVE = $('.header__mainmenu-link.active_menu');
	const DROPDOWN_MENU = $('.dropdown-menu');
	const MENU_BUTTON = $('#header .btn--nav-toggle');

	// Search
	const SEARCH_BAR = $('.header__searchbar');
	const META_SEARCH = $('#meta-search-btn');
	const SEARCH_INPUT = $('#metamenu-search-input');

	// Misc
	const HEADER_BREAKPOINT_LARGE = 1200;  // SCSS breakpoint: $header-breakpoint-large

	let isNavOpen = false;
	let isManualScroll = true; // User scrolls and the scroll is not triggered by an anchor link click

	let prevScroll = window.scrollY || document.documentElement.scrollTop;
	let curScroll;
	let direction = 0;
	const prevDirection = 0;

	$('a[href^="#"]').on('click', function() {
    isManualScroll = false;
    setTimeout(() => { isManualScroll = true; }, 1500);
	});

	const autoShowMenu = () => {
		if (!isNavOpen) {
			if (direction === 2 && curScroll > 100) {
				HEADER.addClass('hide');
			} else {
				HEADER.removeClass('hide');
			}
		}
		// Hide menu if scroll isn't manual
		if (!isManualScroll) {
			HEADER.addClass('hide');
		}
	};

	const checkScrollDirection = () => {

		curScroll = window.scrollY || document.documentElement.scrollTop;
		if (curScroll > prevScroll) {
			direction = 2; // scrolled up
		} else if (curScroll < prevScroll) {
			direction = 1; // scrolled down
		}

		if (curScroll > 160) {
			$('body').addClass('is-scrolling');
		} else {
			$('body').removeClass('is-scrolling');
		}

		if (direction !== prevDirection) {
			autoShowMenu();
		}

		prevScroll = curScroll;
	};

	const closeMobileMenu = (event) => {
		if (MENU_BUTTON.hasClass('open')) {
			toggleMobileMenu();
		}
	}

	const toggleMobileMenu = (event) => {
		if (isNavOpen) {
			$('body').removeClass('fixed');
		}

		isNavOpen = !isNavOpen;

		MENU_BUTTON.toggleClass('open');
		MAIN_MENU.stop().slideToggle();
		MAIN_MENU_LINK_ACTIVE.click();
		closeSearchbar();

		let buttonLabelOpen = 'Menü öffnen';
		let buttonLabelClose = 'Menü schließen';

		MENU_BUTTON.attr('aria-label', (idx, attr) => (attr === buttonLabelOpen ? buttonLabelClose : buttonLabelOpen));

		toggleAttribute(MENU_BUTTON, 'aria-expanded');
	};

	const toggleMobileSearchbar = (event) => {
		if (isNavOpen) {
			$('body').removeClass('fixed');
		}

		isNavOpen = !isNavOpen;

		SEARCH_BAR.stop().slideToggle();
		event && $(event.currentTarget).toggleClass('open');
		// SEARCH_BAR.next().slideUp();
		SEARCH_BAR.slideUp();
		closeDropDownMenu();

		let buttonLabelOpen = 'Menü öffnen';
		let buttonLabelClose = 'Menü schließen';

		META_SEARCH.attr('aria-label', (idx, attr) => (attr === buttonLabelOpen ? buttonLabelClose : buttonLabelOpen));

		toggleAttribute(META_SEARCH, 'aria-expanded');
	};

	const closeDropDownMenu = () => {
		DROPDOWN_MENU.slideUp();
		MAIN_MENU_LINK.removeClass('active');
		MAIN_MENU_LINK.attr('aria-expanded', false);
		$('body').removeClass('fixed');
		HEADER.removeClass('fixed');
	};


	const toggleDropdownMenu = (event) => {
		const $el = $(event.currentTarget);
		event.preventDefault();
		closeSearchbar();
		if ($el.hasClass('active')) {
			closeDropDownMenu();
		} else {
			DROPDOWN_MENU.not($el.next()).hide();
			MAIN_MENU_LINK.not($el).removeClass('active');
			MAIN_MENU_LINK.not($el).attr('aria-expanded', false);

			$el.addClass('active');
			$el.attr('aria-expanded', true);

			$('body').addClass('fixed');

			if ($el.next().hasClass('dropdown-menu')) {
				window.innerWidth >= HEADER_BREAKPOINT_LARGE
					? $el.next().stop().slideDown()
					: $el.next().stop().slideToggle();
			}
		}
	};

	const toggleSearchbar = (event) => {
		const $el = $(event.currentTarget);
		event.preventDefault();
		if (window.innerWidth < HEADER_BREAKPOINT_LARGE) {
			MAIN_MENU.stop().slideUp();
		}
		closeDropDownMenu();
		if ($el.hasClass('active')) {
			closeSearchbar();
		} else {
			SEARCH_BAR.stop().slideDown();
			$el.addClass('active');
			$el.attr('aria-expanded', true);
			SEARCH_INPUT.focus();
		}
	};

	const closeSearchbar = () => {
		SEARCH_BAR.slideUp();
		META_SEARCH.removeClass('active');
		META_SEARCH.attr('aria-expanded', false);
		$('body').removeClass('fixed');
		HEADER.removeClass('fixed');
	};

	const resetDropdownMenuByFocus = (event) => {
		return false;
		const $el = $(event.currentTarget);
		event.preventDefault();
		// closeDropDownMenu();
		DROPDOWN_MENU.not($el.next()).hide();
		MAIN_MENU_LINK.not($el).removeClass('active');
		MAIN_MENU_LINK.not($el).attr('aria-expanded', false);
		$('body').removeClass('fixed');
		HEADER.removeClass('fixed');
	};

	const showMainmenuDesktop = () => {
		closeMobileMenu();
		if (window.innerWidth >= HEADER_BREAKPOINT_LARGE) {
			$('body').removeClass('fixed');
		}
	};

	// EVENTS
	MENU_BUTTON.on('click', (e) => toggleMobileMenu(e));
	MAIN_MENU_LINK.on('click', (e) => toggleDropdownMenu(e));
	META_SEARCH.on('click', (e) => toggleSearchbar(e));
	MAIN_MENU_LINK.on('focus', (e) => ($('body').hasClass('using-keyboard') ? resetDropdownMenuByFocus(e) : null));

	$(document).on('keydown', (e) => (e.key === 'Escape' && DROPDOWN_MENU.is(':visible') ? closeDropDownMenu() : null));
	$('.dropdown-menu__close').click(() => {
		closeDropDownMenu();
		closeSearchbar();
	});

	$(window).on('resize', debounce(showMainmenuDesktop, 100));
	$(window).on('scroll load', () => checkScrollDirection());

});